import React from 'react';
import classNames from 'classnames';

/**
 * LinkButton is a button that looks like a link or 'a' tag.
 *
 * LinkButton is for use at times when you need something that looks like a
 * link but does not have an href that makes sense to set. For example, you
 * may want to have a link that triggers some javascript on click to change
 * something in the UI. There is no good href to use here (and '#' is not a
 * good option because it will not make sense to screen readers) so the best
 * option from a accessibility standpoint is to use a button styled as a link.
 *
 * LinkButton has a default secondary style that can be changed by passing
 * a `type` prop that accepts one of 'primary' or 'secondary'. You can pass
 * an additional class name for context specific styling.
 *
 * @example
 *
 * <LinkButton
 *   type="primary"
 *   className="MyComponent-edit_link"
 *   onClick={() => onThingClicked()}
 * >
 *   Edit this thing!
 * </LinkButton>
 */

const styles = {
  primary: 'h-td-u c-link c-p',
  secondary: 'td-u c-inherit c-p',
};

const LinkButton = ({
  className,
  type,
  disabled,
  pendoClassName,
  ...props
}) => {
  const buttonClassName = classNames(
    'u-resetBtn',
    disabled && 'c-gray-dark',
    !disabled && styles[type],
    className,
    pendoClassName,
  );
  return (
    <button
      className={buttonClassName}
      disabled={disabled}
      type="button"
      {...props}
    />
  );
};

LinkButton.defaultProps = {
  type: 'secondary',
};

export default LinkButton;
